const DigitalAssetsActionTypes = {
    START_FETCH_AVAILABLE_DIGITAL_ASSETS: 'START_FETCH_AVAILABLE_DIGITAL_ASSETS',
    SUCCESS_FETCH_AVAILABLE_DIGITAL_ASSETS: 'SUCCESS_FETCH_AVAILABLE_DIGITAL_ASSETS',
    FINISH_FETCH_AVAILABLE_DIGITAL_ASSETS: 'FINISH_FETCH_AVAILABLE_DIGITAL_ASSETS',
    FAILURE_FETCH_AVAILABLE_DIGITAL_ASSETS: 'FAILURE_FETCH_AVAILABLE_DIGITAL_ASSETS',

    START_ADD_DIGITAL_ASSET: 'START_ADD_DIGITAL_ASSET',
    SUCCESS_ADD_DIGITAL_ASSET: 'SUCCESS_ADD_DIGITAL_ASSET',
    FINISH_ADD_DIGITAL_ASSET: 'FINISH_ADD_DIGITAL_ASSET',
    FAILURE_ADD_DIGITAL_ASSET: 'FAILURE_ADD_DIGITAL_ASSET',
    COMPLETE_REQUEST_ADD_DIGITAL_ASSET: 'COMPLETE_REQUEST_ADD_DIGITAL_ASSET',

    START_SEND_DIGITAL_ASSETS_AMOUNT: 'START_SEND_DIGITAL_ASSETS_AMOUNT',
    SUCCESS_SEND_DIGITAL_ASSETS_AMOUNT: 'SUCCESS_SEND_DIGITAL_ASSETS_AMOUNT',
    FINISH_SEND_DIGITAL_ASSETS_AMOUNT: 'FINISH_SEND_DIGITAL_ASSETS_AMOUNT',
    FAILURE_SEND_DIGITAL_ASSETS_AMOUNT: 'FAILURE_SEND_DIGITAL_ASSETS_AMOUNT',

    START_RECEIVING_QR_CODE_DIGITAL_WALLET: 'START_RECEIVING_QR_CODE_DIGITAL_WALLET',
    SUCCESS_RECEIVING_QR_CODE_DIGITAL_WALLET: 'SUCCESS_RECEIVING_QR_CODE_DIGITAL_WALLET',
    FINISH_RECEIVING_QR_CODE_DIGITAL_WALLET: 'FINISH_RECEIVING_QR_CODE_DIGITAL_WALLET',
    FAILURE_RECEIVING_QR_CODE_DIGITAL_WALLET: 'FAILURE_RECEIVING_QR_CODE_DIGITAL_WALLET',
    CLEAR_RECEIVING_QR_CODE_DIGITAL_WALLET: 'CLEAR_RECEIVING_QR_CODE_DIGITAL_WALLET',

    START_BUY_USDC_COIN: 'START_BUY_USDC_COIN',
    SUCCESS_BUY_USDC_COIN: 'SUCCESS_BUY_USDC_COIN',
    FINISH_BUY_USDC_COIN: 'FINISH_BUY_USDC_COIN',
    FAILURE_BUY_USDC_COIN: 'FAILURE_BUY_USDC_COIN',

    START_BUY_USDC_COIN_WITH_BANK: 'START_BUY_USDC_COIN_WITH_BANK',
    SUCCESS_BUY_USDC_COIN_WITH_BANK: 'SUCCESS_BUY_USDC_COIN_WITH_BANK',
    FINISH_BUY_USDC_COIN_WITH_BANK: 'FINISH_BUY_USDC_COIN_WITH_BANK',
    FAILURE_BUY_USDC_COIN_WITH_BANK: 'FAILURE_BUY_USDC_COIN_WITH_BANK',

    START_TRANSFER_USDC_COIN: 'START_TRANSFER_USDC_COIN',
    SUCCESS_TRANSFER_USDC_COIN: 'SUCCESS_TRANSFER_USDC_COIN',
    FINISH_TRANSFER_USDC_COIN: 'FINISH_TRANSFER_USDC_COIN',
    FAILURE_TRANSFER_USDC_COIN: 'FAILURE_TRANSFER_USDC_COIN',

    START_SEND_USDC_COIN: 'START_SEND_USDC_COIN',
    SUCCESS_SEND_USDC_COIN: 'SUCCESS_SEND_USDC_COIN',
    FINISH_SEND_USDC_COIN: 'FINISH_SEND_USDC_COIN',
    FAILURE_SEND_USDC_COIN: 'FAILURE_SEND_USDC_COIN',

    START_GET_ENCRYPTION_KEY: 'START_GET_ENCRYPTION_KEY',
    SUCCESS_GET_ENCRYPTION_KEY: 'SUCCESS_GET_ENCRYPTION_KEY',
    FINISH_GET_ENCRYPTION_KEY: 'FINISH_GET_ENCRYPTION_KEY',
    FAILURE_GET_ENCRYPTION_KEY: 'FAILURE_GET_ENCRYPTION_KEY',

    START_RECEIVE_DIGITAL_ASSET_BENEFICIARIES: 'START_RECEIVE_DIGITAL_ASSET_BENEFICIARIES',
    SUCCESS_RECEIVE_DIGITAL_ASSET_BENEFICIARIES: 'SUCCESS_RECEIVE_DIGITAL_ASSET_BENEFICIARIES',
    FINISH_RECEIVE_DIGITAL_ASSET_BENEFICIARIES: 'FINISH_RECEIVE_DIGITAL_ASSET_BENEFICIARIES',
    FAILURE_RECEIVE_DIGITAL_ASSET_BENEFICIARIES: 'FAILURE_RECEIVE_DIGITAL_ASSET_BENEFICIARIES',

    START_GET_DIGITAL_ASSET_WALLET_BY_ID: 'START_GET_DIGITAL_ASSETS_WALLET_BY_ID',
    SUCCESS_GET_DIGITAL_ASSET_WALLET_BY_ID: 'SUCCESS_GET_DIGITAL_ASSETS_WALLET_BY_ID',
    FINISH_GET_DIGITAL_ASSET_WALLET_BY_ID: 'FINISH_GET_DIGITAL_ASSETS_WALLET_BY_ID',
    FAILURE_GET_DIGITAL_ASSET_WALLET_BY_ID: 'FAILURE_GET_DIGITAL_ASSETS_WALLET_BY_ID',

    START_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: 'START_GET_DIGITAL_ASSETS_WALLET_ADDRESS_TYPE',
    SUCCESS_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: 'SUCCESS_GET_DIGITAL_ASSETS_WALLET_ADDRESS_TYPE',
    FINISH_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: 'FINISH_GET_DIGITAL_ASSETS_WALLET_ADDRESS_TYPE',
    FAILURE_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: 'FAILURE_GET_DIGITAL_ASSETS_WALLET_ADDRESS_TYPE',
}

export default DigitalAssetsActionTypes
